import { render, staticRenderFns } from "./BônusSemanal.vue?vue&type=template&id=db7205b2&scoped=true"
import script from "./BônusSemanal.vue?vue&type=script&lang=js"
export * from "./BônusSemanal.vue?vue&type=script&lang=js"
import style0 from "./BônusSemanal.vue?vue&type=style&index=0&id=db7205b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7205b2",
  null
  
)

export default component.exports